module.exports = __webpack_public_path__ + "img/3.318d2ac5.jpg";